import { countTagByTag } from '../queries/countTagByTag'

export const tagCountByTagPerDayGauge = {
  id: 'tagCountByTagPerDayGauge',
  queries: [{ ...countTagByTag, interval: 'daily' }],
  title: 'Tag usage',
}
